import React, { Component } from 'react';

import { SCREEN_ID_SUNSETUP_DRIVER_ORDER } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withGeolocation from 'client/helpers/withGeolocation';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupDriverJob from 'client/components/SrSunSetupDriverJob/SrSunSetupDriverJob';

@withGeolocation
@withTransitionHook
@withScreenId(SCREEN_ID_SUNSETUP_DRIVER_ORDER)
@withScrollToTop
class SunSetupDriverJobPage extends Component {
  render() {
    const { match, history, requestGeolocationPermission, getCurrentLocation } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Job"
        backUrl={`/sunsetup/drivers/${match.params.driverId}/orders/${match.params.orderId}`}
        redirectToLastLocation={false}
      >
        <SrSunSetupDriverJob
          driverId={parseInt(match.params.driverId, 10)}
          orderId={parseInt(match.params.orderId, 10)}
          jobId={parseInt(match.params.jobId, 10)}
          history={history}
          requestGeolocationPermission={requestGeolocationPermission}
          getCurrentLocation={getCurrentLocation}
        />
      </SrPartnerPageV2>
    );
  }
}

SunSetupDriverJobPage.displayName = 'SunSetupDriverJobPage';

export default SunSetupDriverJobPage;
